import React, { useState, useRef, useEffect } from "react";
import { withRouter, Link } from "react-router-dom";
import Hamburger from "./Hamburger";
import arrow from "./down-arrow.png";

const Header = ({ history }) => {
  const [state, changeState] = useState({
    initial: false,
    clicked: null,
    menuName: "Menu",
  });

  // let home= useRef(null);
  //  { let element = document.getElementById('button')
  //   ReactDOM.findDOMNode(element).style.backgroundColor = this.state.isClicked?'black' : 'white'}

  const [disabled, setDisabled] = useState(false);

  // To close menu on clicking a menu option
  useEffect(() => {
    history.listen(() => {
      changeState({ clicked: false, menuName: "Menu" });
    });
  }, [history]);

  const menuHandler = () => {
    disableMenu();
    // home.current.display="block";
    if (state.initial === false) {
      changeState({
        initial: null,
        clicked: true,
        menuName: "Close",
      });
    } else if (state.clicked === true) {
      changeState({
        clicked: !state.clicked,
        menuName: "Menu",
      });
    } else if (state.clicked === false) {
      changeState({
        clicked: !state.clicked,
        menuName: "Close",
      });
    }
  };

  //menu button disabled
  const disableMenu = () => {
    setDisabled(!disabled);
    setTimeout(() => {
      setDisabled(false);
    }, 1200);
  };

  return (
    <header>
      <div className="container">
        <div className="wrapper">
          <div className="inner-header">
            <div className="logo">
              <Link
                style={{ display: state.clicked ? "block" : "none" }}
                to="/"
              >
                HOME
              </Link>
            </div>
            <div className="menu">
              <button disabled={disabled} onClick={menuHandler}>
                <p style={{ color: state.clicked ? "white" : "black" }}>
                  KNOW MORE
                  <img
                    src={arrow}
                    style={{ display: state.clicked ? "none" : "block" }}
                    alt="Arrow"
                  ></img>
                </p>
              </button>
            </div>
          </div>
        </div>
      </div>
      <Hamburger state={state} />
    </header>
  );
};

export default withRouter(Header);